import '../index.css';

import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": () => (/* reexport */ StoreContext),
  "Q": () => (/* reexport */ useStoreContext)
});

;// CONCATENATED MODULE: external "react"
var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const external_react_namespaceObject = x({ ["createContext"]: () => __WEBPACK_EXTERNAL_MODULE_react__.createContext, ["useContext"]: () => __WEBPACK_EXTERNAL_MODULE_react__.useContext });
;// CONCATENATED MODULE: ./StoreContext.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const StoreContext_module = ({});
;// CONCATENATED MODULE: ./StoreContext.tsx

// This is a small hack for npm component generation, should not be removed

// Given that StoreContext is created server side, we can cast here to avoid typing errors
const StoreContext = (0,external_react_namespaceObject.createContext)(null);
const useStoreContext = () => {
    const context = (0,external_react_namespaceObject.useContext)(StoreContext);
    return context;
};

;// CONCATENATED MODULE: ./index.tsx


var __webpack_exports__StoreContext = __webpack_exports__.x;
var __webpack_exports__useStoreContext = __webpack_exports__.Q;
export { __webpack_exports__StoreContext as StoreContext, __webpack_exports__useStoreContext as useStoreContext };
